import React, { useEffect } from "react";
import Axios from "axios";
import * as Constants from "../../consts/Constants.js";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import "../../styles/css/SearchByUserAndDate.css";
import { formatDateYYYYMMDD } from "../../utils/DateUtils";
import { ColorButton } from "./CustomButton.js";
import Typography from "@material-ui/core/Typography";

const SearchByUserAndDate = (props) => {
  const [state, setState] = React.useState({
    users: [],
    user: { userId: 0, name: "", lastName: "", email: "" },
  });

  const handleUserChange = (e, values) => {
    setState({ ...state, user: values });
  };

  useEffect(() => {
    let source = Axios.CancelToken.source();
    Axios.get(Constants.FINAL_URL_USERS, {
      cancelToken: source.token,
    })
      .then((response) => {
        let data = [];
        response.data.forEach((usersItem) => {
          data.push(usersItem);
        });
        setState({ ...state, users: data });
      })
      .catch(() => {});
    return () => source.cancel();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    let date = new Date(e.target.date.value + "T00:00").getTime();
    let userId = state.user.userId;
    props.onSearch(userId, date);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={
        props.horizontal
          ? "searchByUserAndDateHorizontal"
          : "searchByUserAndDate"
      }
    >
      <Typography style={{ marginTop: "15px" }} variant="h6" gutterBottom>
        {props.title}
      </Typography>
      <Autocomplete
        id="free-solo-demo"
        freeSolo
        value={state.user}
        className="inputsSearch"
        onChange={handleUserChange}
        options={state.users}
        getOptionLabel={(option) =>
          option.name
            ? `${option.name} ${option.lastName} - ${option.email} `
            : ""
        }
        renderInput={(params) => (
          <TextField
            style={{ top: "-4px" }}
            name="user"
            {...params}
            label="Usuario"
            margin="normal"
          />
        )}
      />
      <TextField
        id="datetime"
        label="Fecha"
        type="date"
        name="date"
        className="inputsSearch"
        defaultValue={formatDateYYYYMMDD(new Date().getTime())}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <ColorButton className="inputsSearch" type="submit">
        BUSCAR
      </ColorButton>
    </form>
  );
};

export default SearchByUserAndDate;
